import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const IconButton = ({
  icon,
  onClick,
  size = 'sm',
  variant = 'light',
  className = 'btn-light border-secondary text-primary',
  iconClassName = 'text-info',
  hoverClassName = 'badge-danger border-danger',
  hoverIconClassName = 'text-danger',
  disabled = false,
  title,
  'data-testid': dataTestId,
  ...rest
}) => {
  const [hover, setHover] = useState(false)

  return (
    <Button
      size={size}
      className={`btn btn-sm ${hover ? hoverClassName : className}`}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled}
      title={title}
      data-testid={dataTestId}
      {...rest}
    >
      <FontAwesomeIcon icon={icon} className={hover ? hoverIconClassName : iconClassName} />
    </Button>
  )
}

export default IconButton
